module.exports = __webpack_public_path__ + "img/blank-comic-book_B0997RR95K.8424dd5a.jpg";